'use es6';

export var DEFAULT_COLOR = '#425b76';